import AppTour from 'app/tour/AppTour';
import { TourStepRaw } from 'app/tour/index';

const SpotlightIdStep0 = 'tile-favorite-icon-spotlight';
const SpotlightIdStep1 = 'tile-info-icon-spotlight';
const SpotlightIdStep2 = 'tile-full-spotlight';

export default class HomePageTour extends AppTour {
    static tourName: string = 'home-page';

    async endTour(): Promise<any> {
        this.spotlight.removeSpotLight(SpotlightIdStep0);
        this.spotlight.removeSpotLight(SpotlightIdStep1);
        this.spotlight.removeSpotLight(SpotlightIdStep2);
        return super.endTour();
    }
    async startTour(): Promise<any> {
        const selector = window.location.hash.includes('/list/') ? 'tile-element--view-list' : 'tile-element__header';
        this.spotlight.createInterval([
            { spotlightId: SpotlightIdStep0, iconSelector: '.tile-element__favorite' },
            { spotlightId: SpotlightIdStep1, iconSelector: '.tile-element__info' },
            { spotlightId: SpotlightIdStep2, iconSelector: `.${selector}` },
        ]);
        return super.startTour();
    }
    rawSteps: Array<TourStepRaw> = [
        {
            target: `#${SpotlightIdStep0}`,
            content: 'step_0',
            placement: 'right-start',
        },
        {
            target: `#${SpotlightIdStep1}`,
            content: 'step_1',
            placement: 'right-start',
        },
        {
            target: `#${SpotlightIdStep2}`,
            content: 'step_2',
            placement: 'right-start',
        },
    ];
}
